import * as React from "react"
import {graphql, Link, navigate} from "gatsby";
import {useState} from 'react';
import Layout from "../components/layout";
import {GatsbyImage, getImage} from "gatsby-plugin-image"
import queryString from "query-string";

// markup
const IndexPage = ({data, location}) => {
    const urlParams = queryString.parse(location.search);
    const urlCat = urlParams.urlCat ?? ''

    const dataPages = data.allMarkdownRemark.edges;
    let categories = [];
    const [dataPagesList, setDataPagesList] = useState(dataPages);
    const [searchValue, setSearchValue] = useState('');
    const [catSelected, setCatSelected] = useState(urlCat);

    function orderChange(event) {

        setDataPagesList([])
        setTimeout(function () {
            if (event.target.value === "AAsc") {
                setDataPagesList(dataPages.sort((a, b) => (a.node.frontmatter.title > b.node.frontmatter.title ? 1 : -1)))
            } else if (event.target.value === "ADesc") {
                setDataPagesList(dataPages.sort((a, b) => (a.node.frontmatter.title < b.node.frontmatter.title ? 1 : -1)))
            } else if (event.target.value === "DAsc") {
                setDataPagesList(dataPages.sort((a, b) => (a.node.frontmatter.date > b.node.frontmatter.date ? 1 : -1)))
            } else if (event.target.value === "DDesc") {
                setDataPagesList(dataPages.sort((a, b) => (a.node.frontmatter.date < b.node.frontmatter.date ? 1 : -1)))
            }
        }, 500)

    }

    function catChange(event) {
        changeCatSelected(event.target.value.replace(/[^\w\s]/gi, ''))
    }

    function inputChange(event) {
        setSearchValue(event.target.value);
    }

    function changeCatSelected(cat) {
        setCatSelected(cat.replace(/[^\w\s]/gi, ''))
        let newUrl = cat ? "/?urlCat=" + cat.replace(/[^\w\s]/gi, '') + '#filter' : "/" + '#filter'
        let navigationCat = navigate(newUrl);
    }

    dataPages.forEach(data => {
        let dataPage = data.node.frontmatter
        if (!categories.includes(dataPage.cat)) {
            categories.push(dataPage.cat);
        }
    })

    return (
        <Layout>
            <title>Inicio</title>

            <div className="filter" id={'filter'}>
                {categories.map(category => {
                    return (
                        <button key={category} className={catSelected === category.replace(/[^\w\s]/gi, '') ? 'active' : ''}
                                onClick={() => changeCatSelected(category)}>{category}</button>
                    )
                })}
                <button className={catSelected === '' ? 'active' : ''} onClick={() => changeCatSelected('')}>TODOS
                </button>

            </div>
            <div className="filter-responsive">
                <select onChange={catChange}>
                    <option value="">TODOS</option>
                    {categories.map(category => {
                        return (
                            <option key={category} value={category.replace(/[^\w\s]/gi, '')}>{category}</option>
                        )
                    })}
                </select>
            </div>
            <div className="search">
                <input placeholder={'Buscar Videos'} type="text" value={searchValue} onChange={inputChange}/>
                <p>Ordenar por: <select onChange={orderChange}>
                    <option value="AAsc">Orden Alfabético A - Z</option>
                    <option value="ADesc">Orden Alfabético Z - A</option>
                    {/*<option value="DDesc">Fecha Más Reciente</option>
                    <option value="DAsc">Fecha Más Antiguo</option>*/}
                </select></p>
            </div>
            <div className="grid" id={"grid"}>
                {!dataPagesList.length && <p>Cargando</p>}
                {dataPagesList.map(dataPage => {
                    let title = dataPage.node.frontmatter.title.toLowerCase()
                    let param = catSelected ? '?urlCat=' + catSelected.replace(/[^\w\s]/gi, '') : ''
                    if ((!catSelected || catSelected.replace(/[^\w\s]/gi, '') === dataPage.node.frontmatter.cat.replace(/[^\w\s]/gi, '')) &&
                        title.includes(searchValue.toLowerCase())) {
                        return (
                            <div className={'item'} key={dataPage.node.frontmatter.slug}>
                                <div className="img">
                                    <Link className={'clean'} to={'/' + dataPage.node.frontmatter.slug + '.html' + param}>
                                        <GatsbyImage image={getImage(dataPage.node.frontmatter.thumbnail)}
                                                     alt={dataPage.node.frontmatter.title}/>
                                    </Link>
                                </div>
                                <h3 dangerouslySetInnerHTML={{__html: dataPage.node.frontmatter.title}}></h3>
                                {/*<p>{dataPage.node.frontmatter.date}</p>*/}
                                <p>{dataPage.node.frontmatter.cat}</p>
                                <Link to={'/' + dataPage.node.frontmatter.slug + '.html' + param}>Ver más</Link>
                            </div>
                        )
                    }
                })}
            </div>

        </Layout>
    )
}

export default IndexPage

export const dataMD = graphql`
  query {
    allMarkdownRemark {
      edges {
        node {
          frontmatter {
            slug
            title
            cat,
            date(formatString: "MMMM DD, YYYY", locale: "es")
            thumbnail {
              childImageSharp {             
                gatsbyImageData(
                  width: 365
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                )
              }
            }
          }
        }
      }
    }
  }
`
